module.exports = __webpack_public_path__ + "media/images/mypage/btn03-30065381a3fbb1332c2daa520ddfe242.gif";